import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { API_ADDRESS, PAGE_TITLE_BASE } from './constants.js';
import { useNavigate } from "react-router";

import { Dimmer, Loader, Segment, Card, CardContent, CardHeader } from 'semantic-ui-react'

export function Artists(props) {
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [artists, setArtists] = useState([]);
  const [totalUK, setTotalUK] = useState(0);
  const [totalInternational, setTotalInternational] = useState(0);

  document.title = 'Artists | ' + PAGE_TITLE_BASE;

  const search = useCallback(() => {  
    var url = `${API_ADDRESS}/artists`;

    fetch(url)
      .then(function(response) {
        return response.json()
      })
      .then(function(json) {
        setArtists(json);
        setTotalUK(json['UK'].length);
        setTotalInternational(json['International'].length);
        setLoading(false);
      })
      .catch(function(ex) {
        setLoading(false);
        console.log(ex);
      })
  }, []); 

  useEffect(() => { if(loading) { search() } }, [loading, search])

  const onClickHandler = (e, link) => {
    if(e.ctrlKey || e.metaKey){
      window.open(link, '_blank');
    } else {
      navigate(link);
    }
  }

  return (
    <div>
      <Segment className="browse-table-segment">
        <Dimmer active={loading}>
          <Loader size='large'>Loading</Loader>
        </Dimmer>
        <h1>Artists</h1>
        <p>Below are the names of the {totalUK} UK artists in our database. Click the Card to view details</p>
        {artists.length === 0 && 
          <Card color='orange' style={{width:'100%'}}>
            <CardContent>
              <CardHeader>No artists found</CardHeader>
            </CardContent>
          </Card>
        }
        <div className="Cards">
          {'UK' in artists && artists['UK'].map(function(artist, i) {
            let color = 'orange';
            if(i % 7 === 1) { color = 'teal'; }
            if(i % 7 === 2) { color = 'purple'; }
            if(i % 7 === 3) { color = 'green'; }
            if(i % 7 === 4) { color = 'yellow'; }
            if(i % 7 === 5) { color = 'red'; }
            if(i % 7 === 6) { color = 'pink'; }

            return <Card key={artist.artist_id}
              color={color}
              style={{width: '290px'}}
              onClick={(e) => onClickHandler(e, '/artist/' + artist.artist_id)}
            >
              <CardContent>
                <CardHeader>{'first_name' in artist && <>{artist.first_name} </>}{artist.last_name}</CardHeader>
              </CardContent>
            </Card>
          })}
        </div>
        <hr style={{marginTop: '20px', marginBottom: '20px'}}/>
        <div>
          <h2 style={{marginBottom: '0px'}}>International Visitors</h2>
          <p>Below are the names of the {totalInternational} International artists in our database. Click the Card to view details</p>
          <div className="Cards" style={{marginTop: '0px'}}>
            {'International' in artists && artists['International'].map(function(artist, i) {
              let color = 'orange';
              if(i % 7 === 1) { color = 'teal'; }
              if(i % 7 === 2) { color = 'purple'; }
              if(i % 7 === 3) { color = 'green'; }
              if(i % 7 === 4) { color = 'yellow'; }
              if(i % 7 === 5) { color = 'red'; }
              if(i % 7 === 6) { color = 'pink'; }

              return <Card key={artist.artist_id}
                color={color}
                style={{width: '290px'}}
                onClick={(e) => onClickHandler(e, '/artist/' + artist.artist_id)}
              >
                <CardContent>
                  <CardHeader>{'first_name' in artist && <>{artist.first_name} </>}{artist.last_name}</CardHeader>
                </CardContent>
              </Card>
            })}
          </div>
        </div>
      </Segment>
    </div>
  );
}